





































import Vue from 'vue'
import CustomTrainingForm from '@/components/CustomTrainingForm.vue'
import { toRoman } from 'roman-numerals'
import _range from 'lodash/range'

export default Vue.extend({
  props: {
    selectedDegrees: { type: Array as () => number[], required: false },
    custom: { type: Boolean, default: false }
  },
  components: {
    CustomTrainingForm
  },
  data() {
    return {
      intervals: _range(2, 8).map(d => [1, d]),
      progressions: [
        [1, 4, 5],
        [1, 6, 4, 5],
        [1, 5, 6, 3],
        [1, 5, 6, 4],
        [2, 5, 1],
        [1, 6, 7],
        [1, 4, 7]
      ],
      showCustom: false
    }
  },
  computed: {
    allPresetKeys(): string[] {
      return [...this.intervals, ...this.progressions].map(d => d.join())
    }
  },
  methods: {
    toDisplay(degrees: number[]) {
      return degrees.map(d => toRoman(d)).join(' - ')
    },
    isActive(degrees: number[]) {
      return !this.custom && this.selectedDegrees && this.selectedDegrees.join() === degrees.join()
    },
    makeQuery(progression: number[]) {
      return Object.assign({}, this.$route.query, {
        degrees: progression.join(',')
      })
    }
  }
})
